<template>
  <v-navigation-drawer
    v-model="$store.state.NAV.drawer"
    fixed
    :temporary="hover"
    :permanent="!hover"
    @input="iDrawer"
    app
  >
    <v-list nav>
      <v-list-item v-if="isLogin" two-line color="primary">
        <v-list-item-avatar>
          <img
            v-if="$store.state.USER.avatar"
            :src="$store.state.USER.avatar"
            :alt="$store.state.USER.username"
          />
          <v-icon v-else color="primary">account_circle</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{
            $store.state.USER.username
          }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $store.state.USER.emailVerified
              ? $store.state.USER.email
              : $t("navigation.tab_unemail")
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-else color="primary">
        <v-list-item-avatar>
          <v-icon color="primary">account_circle</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-btn color="primary" to="/account/login">{{$t('navigation.tab_toLogin')}}</v-btn>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mb-2"></v-divider>
      <!--**MENUS ON TAB**-->
      <template v-if="/^\/application*/.test($route.path)">
        <v-list-item
          v-for="(tab, index) in tabs"
          :key="'TAB-' + index"
          :to="tab.to"
          dense
        >
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>{{$t(`navbar.${tab.name}`)}}</v-list-item-content>
        </v-list-item>
        <v-divider class="mb-2"></v-divider>
      </template>
      <!--**MENUS USER**-->
      <template v-if="isLogin">
        <v-list-item
          v-for="item in items"
          :key="item.title"
          :to="item.link.indexOf('http') === -1 ? '/user/' + item.link : null"
          :href="item.link.indexOf('http') !== -1 ? item.link : null"
          :target="item.link.indexOf('http') !== -1 ? '_black' : null"
          :disabled="item.disabled"
        >
          <v-list-item-icon>
            <v-icon color="primary">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t(`navigation.${item.title}`) }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon
            class="my-auto"
            v-if="item.link.indexOf('http') !== -1"
          >
            <v-icon small color="blue-grey">open_in_new</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-divider class="mb-2"></v-divider>
      </template>
      <!--**SETTING**-->
      <v-subheader>GOBAL SETTING</v-subheader>
      <v-list-item>
        <v-list-item-icon>
            <v-icon color="primary">brightness_2</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <span>{{$t('navigation.tab_set_night')}}</span>
        </v-list-item-content>
        <v-switch v-model="themeSwitch" class="mt-0" hide-details></v-switch>
      </v-list-item>
      <v-list-item v-if="/\/(\w+)\/(\w+)/.test($route.fullPath)">
        <v-list-item-content>
          <v-select v-model="langModel" :items="langItems" hide-details solo flat label="Language" @change="setLang">
            <v-icon class="mr-3" slot="prepend" color="primary">translate</v-icon>
          </v-select>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <template v-slot:append v-if="isLogin">
      <div class="pa-2">
        <v-btn block color="warning" to="/account/logout">{{$t('navigation.tab_logout')}}</v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
// router to menu.
const getMainRouterToMenu = () => {
  let routeArr = require("@/core/router/main.p.js");
  let menus = [];
  for (let i in routeArr.default.children) {
    let routeTabs = routeArr.default.children;
    if (routeTabs[i].meta)
      if (routeTabs[i].meta.menu.show)
        menus.push({
          to: routeTabs[i].path == "" ? "/" : routeTabs[i].path,
          name: routeTabs[i].meta.menu.name,
        });
  }
  return menus;
};
export default {
  data() {
    return {
      tabs: getMainRouterToMenu(),
      isLogin: localStorage.getItem("ms-user-sessionToken") ? true : false,
      // isLogin: false,
      items: [
        { title: "tab_dashborad", icon: "dashboard", link: "dashboard" },
        { title: "tab_games", icon: "games", link: "mygames" },
        { title: "tab_skin", icon: "accessibility", link: "skin" },
        { title: "tab_account", icon: "account_box", link: "account" },
        {
          title: "tab_icloud",
          icon: "cloud",
          link: "https://mycloud.makjust.com",
          disabled: true,
        },
      ],
      langModel: this.$store.state.OPTIONS._local_lang.type,
      themeSwitch: false
    };
  },
  mounted() {
    this.isLogin = this.$store.state.USER.sessionToken ? true : false;
  },
  computed: {
    bg() {
      return this.background
        ? "https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg"
        : undefined;
    },
    langItems(){
      let items = [];
      let langValues = Object.keys(require("@/i18n/messages.js").default)
      langValues.forEach(value => {
        items.push({
          text: this.$store.state.OPTIONS._local_lang.values[value],
          value: value
        })
      })
      return items
    },
  },
  methods: {
    iDrawer(res) {
      this.$emit("navi-input", res);
    },
    setLang($lang) {
      this.$i18n.locale = $lang;
      this.$store.dispatch("setLang", $lang);
    },
  },
  props: {
    hover: Boolean,
  },
};
</script>